import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { del } from 'utils/http'

export const useAgencyDelete = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const deleteAgency = () => del(`/management/customers/${customerId}/master`)

  return useMutation({
    mutationFn: deleteAgency,
    onSuccess: async () => {
      addNotification('Agency plan removed')

      await queryClient.invalidateQueries({ queryKey: ['customer', String(customerId)] })
    },
  })
}
